/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_Request_FollowInputs */

const en_follow_request_follow = /** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request Follow`)
};

const es_follow_request_follow = /** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar Seguir`)
};

const fr_follow_request_follow = /** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander à suivre`)
};

const de_follow_request_follow = /** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgen anfragen`)
};

const id_follow_request_follow = /** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta Ikuti`)
};

/** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */
const ja_follow_request_follow = en_follow_request_follow;

/** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */
const zh_follow_request_follow = en_follow_request_follow;

/** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */
const ar_follow_request_follow = en_follow_request_follow;

/** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */
const it_follow_request_follow = en_follow_request_follow;

/** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */
const ru_follow_request_follow = en_follow_request_follow;

/** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */
const pt_follow_request_follow = en_follow_request_follow;

/** @type {(inputs: Follow_Request_FollowInputs) => LocalizedString} */
const ko_follow_request_follow = en_follow_request_follow;

/**
* | output |
* | --- |
* | "Request Follow" |
*
* @param {Follow_Request_FollowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_request_follow = /** @type {((inputs?: Follow_Request_FollowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_Request_FollowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_request_follow(inputs)
	if (locale === "es") return es_follow_request_follow(inputs)
	if (locale === "fr") return fr_follow_request_follow(inputs)
	if (locale === "de") return de_follow_request_follow(inputs)
	if (locale === "ja") return ja_follow_request_follow(inputs)
	if (locale === "zh") return zh_follow_request_follow(inputs)
	if (locale === "ar") return ar_follow_request_follow(inputs)
	if (locale === "id") return id_follow_request_follow(inputs)
	if (locale === "it") return it_follow_request_follow(inputs)
	if (locale === "ru") return ru_follow_request_follow(inputs)
	if (locale === "pt") return pt_follow_request_follow(inputs)
	return ko_follow_request_follow(inputs)
});